module.exports = __webpack_public_path__ + "static/media/Empowering Students.0248f254.png";